<div [style.min-height.vh]="100" class="main">
  <app-toolbar></app-toolbar>
  <router-outlet></router-outlet>
</div>
